const newsletterWorkflowDe = {
  title: 'Freigabe und Versand',
  notice:
    'Die Freigabe dokumentiert technische Voraussetzungen, ersetzt aber keine rechtliche Prüfung des konkreten Versands.',
  recipients: 'Freigegebene Empfänger',
  excluded: 'Ausgeschlossen',
  estimatedCost: 'Kostenschätzung',
  snapshot: 'Zielgruppen-Snapshot',
  accepted: 'Vom Provider angenommen',
  pending: 'Ausstehend',
  retry: 'Temporäre Fehler',
  failedCount: 'Nicht versendet',
  scheduledFor: 'Geplant für {{date}}',
  reason: 'Dokumentierte Begründung',
  reasonHint: 'Mindestens 10 Zeichen; wird unveränderlich protokolliert.',
  approvalConfirmation: 'Ich habe Inhalt, Pflichtangaben und Empfängervoraussetzungen geprüft.',
  costConfirmation: 'Ich habe Empfängerzahl und Kostenschätzung geprüft.',
  scheduledAt: 'Versandzeitpunkt',
  timezone: 'IANA-Zeitzone',
  scheduleConfirmation:
    'Ich bestätige diesen Snapshot, Zeitpunkt und produktiven Versand ausdrücklich.',
  submit: 'Zur Prüfung einreichen',
  approve: 'Unveränderlich freigeben',
  schedule: 'Versand planen',
  pause: 'Versand pausieren',
  resume: 'Versand fortsetzen',
  cancel: 'Nicht versendete Nachrichten abbrechen',
  updated: 'Kampagnenstatus wurde aktualisiert.',
  failed: 'Kampagnenaktion fehlgeschlagen.',
  status: {
    DRAFT: 'Entwurf',
    IN_REVIEW: 'In Prüfung',
    APPROVED: 'Freigegeben',
    SCHEDULED: 'Geplant',
    SENDING: 'Wird versendet',
    PAUSED: 'Pausiert',
    SENT: 'An Provider übergeben',
    PARTIALLY_FAILED: 'Teilweise fehlgeschlagen',
    CANCELLED: 'Abgebrochen',
    FAILED: 'Fehlgeschlagen',
    ARCHIVED: 'Archiviert',
  },
  event: {
    SUBMITTED: 'Eingereicht',
    APPROVED: 'Freigegeben',
    SCHEDULED: 'Geplant',
    STARTED: 'Gestartet',
    PAUSED: 'Pausiert',
    RESUMED: 'Fortgesetzt',
    CANCELLED: 'Abgebrochen',
    COMPLETED: 'Abgeschlossen',
    FAILED: 'Fehlgeschlagen',
    RECOVERED: 'Wiederhergestellt',
  },
} as const;

const newsletterWorkflowEn = {
  title: 'Approval and delivery',
  notice:
    'Approval documents technical prerequisites; it does not replace legal review of the specific delivery.',
  recipients: 'Approved recipients',
  excluded: 'Excluded',
  estimatedCost: 'Cost estimate',
  snapshot: 'Audience snapshot',
  accepted: 'Accepted by provider',
  pending: 'Pending',
  retry: 'Temporary failures',
  failedCount: 'Not sent',
  scheduledFor: 'Scheduled for {{date}}',
  reason: 'Documented reason',
  reasonHint: 'At least 10 characters; stored in the immutable log.',
  approvalConfirmation: 'I reviewed the content, mandatory details and recipient prerequisites.',
  costConfirmation: 'I reviewed the recipient count and cost estimate.',
  scheduledAt: 'Delivery time',
  timezone: 'IANA time zone',
  scheduleConfirmation: 'I explicitly confirm this snapshot, time and production delivery.',
  submit: 'Submit for review',
  approve: 'Approve immutable snapshot',
  schedule: 'Schedule delivery',
  pause: 'Pause delivery',
  resume: 'Resume delivery',
  cancel: 'Cancel unsent messages',
  updated: 'Campaign status was updated.',
  failed: 'Campaign action failed.',
  status: {
    DRAFT: 'Draft',
    IN_REVIEW: 'In review',
    APPROVED: 'Approved',
    SCHEDULED: 'Scheduled',
    SENDING: 'Sending',
    PAUSED: 'Paused',
    SENT: 'Handed to provider',
    PARTIALLY_FAILED: 'Partially failed',
    CANCELLED: 'Cancelled',
    FAILED: 'Failed',
    ARCHIVED: 'Archived',
  },
  event: {
    SUBMITTED: 'Submitted',
    APPROVED: 'Approved',
    SCHEDULED: 'Scheduled',
    STARTED: 'Started',
    PAUSED: 'Paused',
    RESUMED: 'Resumed',
    CANCELLED: 'Cancelled',
    COMPLETED: 'Completed',
    FAILED: 'Failed',
    RECOVERED: 'Recovered',
  },
} as const;

const newsletterWorkflowTr = {
  title: 'Onay ve gönderim',
  notice: 'Onay teknik koşulları belgeler; belirli gönderinin hukuki incelemesinin yerine geçmez.',
  recipients: 'Onaylanan alıcılar',
  excluded: 'Hariç tutulan',
  estimatedCost: 'Maliyet tahmini',
  snapshot: 'Hedef kitle anlık görüntüsü',
  accepted: 'Sağlayıcı kabul etti',
  pending: 'Bekliyor',
  retry: 'Geçici hatalar',
  failedCount: 'Gönderilmedi',
  scheduledFor: '{{date}} için planlandı',
  reason: 'Belgelenmiş gerekçe',
  reasonHint: 'En az 10 karakter; değiştirilemez kayda yazılır.',
  approvalConfirmation: 'İçeriği, zorunlu bilgileri ve alıcı koşullarını kontrol ettim.',
  costConfirmation: 'Alıcı sayısını ve maliyet tahminini kontrol ettim.',
  scheduledAt: 'Gönderim zamanı',
  timezone: 'IANA saat dilimi',
  scheduleConfirmation: 'Bu anlık görüntüyü, zamanı ve üretim gönderimini açıkça onaylıyorum.',
  submit: 'İncelemeye gönder',
  approve: 'Değiştirilemez olarak onayla',
  schedule: 'Gönderimi planla',
  pause: 'Gönderimi duraklat',
  resume: 'Gönderime devam et',
  cancel: 'Gönderilmemiş iletileri iptal et',
  updated: 'Kampanya durumu güncellendi.',
  failed: 'Kampanya işlemi başarısız oldu.',
  status: {
    DRAFT: 'Taslak',
    IN_REVIEW: 'İncelemede',
    APPROVED: 'Onaylandı',
    SCHEDULED: 'Planlandı',
    SENDING: 'Gönderiliyor',
    PAUSED: 'Duraklatıldı',
    SENT: 'Sağlayıcıya aktarıldı',
    PARTIALLY_FAILED: 'Kısmen başarısız',
    CANCELLED: 'İptal edildi',
    FAILED: 'Başarısız',
    ARCHIVED: 'Arşivlendi',
  },
  event: {
    SUBMITTED: 'İncelemeye gönderildi',
    APPROVED: 'Onaylandı',
    SCHEDULED: 'Planlandı',
    STARTED: 'Başlatıldı',
    PAUSED: 'Duraklatıldı',
    RESUMED: 'Devam ettirildi',
    CANCELLED: 'İptal edildi',
    COMPLETED: 'Tamamlandı',
    FAILED: 'Başarısız',
    RECOVERED: 'Kurtarıldı',
  },
} as const;

const newsletterWorkflowFr = {
  title: 'Approbation et envoi',
  notice:
    'L’approbation documente les prérequis techniques, sans remplacer l’examen juridique de l’envoi concret.',
  recipients: 'Destinataires approuvés',
  excluded: 'Exclus',
  estimatedCost: 'Estimation du coût',
  snapshot: 'Instantané de l’audience',
  accepted: 'Acceptés par le fournisseur',
  pending: 'En attente',
  retry: 'Erreurs temporaires',
  failedCount: 'Non envoyés',
  scheduledFor: 'Planifié pour le {{date}}',
  reason: 'Motif documenté',
  reasonHint: '10 caractères minimum ; inscrit dans le journal immuable.',
  approvalConfirmation:
    'J’ai vérifié le contenu, les mentions obligatoires et les conditions des destinataires.',
  costConfirmation: 'J’ai vérifié le nombre de destinataires et l’estimation du coût.',
  scheduledAt: 'Date d’envoi',
  timezone: 'Fuseau horaire IANA',
  scheduleConfirmation:
    'Je confirme explicitement cet instantané, cette date et l’envoi en production.',
  submit: 'Soumettre à examen',
  approve: 'Approuver l’instantané immuable',
  schedule: 'Planifier l’envoi',
  pause: 'Suspendre l’envoi',
  resume: 'Reprendre l’envoi',
  cancel: 'Annuler les messages non envoyés',
  updated: 'Le statut de la campagne a été mis à jour.',
  failed: 'L’action sur la campagne a échoué.',
  status: {
    DRAFT: 'Brouillon',
    IN_REVIEW: 'En examen',
    APPROVED: 'Approuvée',
    SCHEDULED: 'Planifiée',
    SENDING: 'En cours d’envoi',
    PAUSED: 'Suspendue',
    SENT: 'Transmise au fournisseur',
    PARTIALLY_FAILED: 'Échec partiel',
    CANCELLED: 'Annulée',
    FAILED: 'Échec',
    ARCHIVED: 'Archivée',
  },
  event: {
    SUBMITTED: 'Soumise',
    APPROVED: 'Approuvée',
    SCHEDULED: 'Planifiée',
    STARTED: 'Démarrée',
    PAUSED: 'Suspendue',
    RESUMED: 'Reprise',
    CANCELLED: 'Annulée',
    COMPLETED: 'Terminée',
    FAILED: 'Échec',
    RECOVERED: 'Récupérée',
  },
} as const;

const newsletterWorkflowEs = {
  title: 'Aprobación y envío',
  notice:
    'La aprobación documenta los requisitos técnicos, pero no sustituye la revisión jurídica del envío concreto.',
  recipients: 'Destinatarios aprobados',
  excluded: 'Excluidos',
  estimatedCost: 'Estimación de costes',
  snapshot: 'Instantánea del público',
  accepted: 'Aceptados por el proveedor',
  pending: 'Pendientes',
  retry: 'Errores temporales',
  failedCount: 'No enviados',
  scheduledFor: 'Programado para {{date}}',
  reason: 'Motivo documentado',
  reasonHint: 'Al menos 10 caracteres; se guarda en el registro inmutable.',
  approvalConfirmation:
    'He revisado el contenido, los datos obligatorios y los requisitos de los destinatarios.',
  costConfirmation: 'He revisado el número de destinatarios y la estimación de costes.',
  scheduledAt: 'Fecha de envío',
  timezone: 'Zona horaria IANA',
  scheduleConfirmation:
    'Confirmo expresamente esta instantánea, la fecha y el envío en producción.',
  submit: 'Enviar a revisión',
  approve: 'Aprobar instantánea inmutable',
  schedule: 'Programar envío',
  pause: 'Pausar envío',
  resume: 'Reanudar envío',
  cancel: 'Cancelar mensajes no enviados',
  updated: 'Se actualizó el estado de la campaña.',
  failed: 'Falló la acción de la campaña.',
  status: {
    DRAFT: 'Borrador',
    IN_REVIEW: 'En revisión',
    APPROVED: 'Aprobada',
    SCHEDULED: 'Programada',
    SENDING: 'Enviando',
    PAUSED: 'Pausada',
    SENT: 'Entregada al proveedor',
    PARTIALLY_FAILED: 'Error parcial',
    CANCELLED: 'Cancelada',
    FAILED: 'Fallida',
    ARCHIVED: 'Archivada',
  },
  event: {
    SUBMITTED: 'Enviada a revisión',
    APPROVED: 'Aprobada',
    SCHEDULED: 'Programada',
    STARTED: 'Iniciada',
    PAUSED: 'Pausada',
    RESUMED: 'Reanudada',
    CANCELLED: 'Cancelada',
    COMPLETED: 'Finalizada',
    FAILED: 'Fallida',
    RECOVERED: 'Recuperada',
  },
} as const;

const newsletterWorkflowRu = {
  title: 'Согласование и отправка',
  notice:
    'Согласование фиксирует технические условия, но не заменяет юридическую проверку конкретной отправки.',
  recipients: 'Согласованные получатели',
  excluded: 'Исключено',
  estimatedCost: 'Оценка стоимости',
  snapshot: 'Снимок аудитории',
  accepted: 'Принято провайдером',
  pending: 'Ожидает',
  retry: 'Временные ошибки',
  failedCount: 'Не отправлено',
  scheduledFor: 'Запланировано на {{date}}',
  reason: 'Задокументированное основание',
  reasonHint: 'Не менее 10 символов; сохраняется в неизменяемом журнале.',
  approvalConfirmation: 'Я проверил содержимое, обязательные сведения и условия для получателей.',
  costConfirmation: 'Я проверил число получателей и оценку стоимости.',
  scheduledAt: 'Время отправки',
  timezone: 'Часовой пояс IANA',
  scheduleConfirmation: 'Я явно подтверждаю этот снимок, время и рабочую отправку.',
  submit: 'Отправить на проверку',
  approve: 'Согласовать неизменяемый снимок',
  schedule: 'Запланировать отправку',
  pause: 'Приостановить отправку',
  resume: 'Продолжить отправку',
  cancel: 'Отменить неотправленные сообщения',
  updated: 'Статус кампании обновлён.',
  failed: 'Действие с кампанией завершилось ошибкой.',
  status: {
    DRAFT: 'Черновик',
    IN_REVIEW: 'На проверке',
    APPROVED: 'Согласовано',
    SCHEDULED: 'Запланировано',
    SENDING: 'Отправляется',
    PAUSED: 'Приостановлено',
    SENT: 'Передано провайдеру',
    PARTIALLY_FAILED: 'Частичная ошибка',
    CANCELLED: 'Отменено',
    FAILED: 'Ошибка',
    ARCHIVED: 'Архивировано',
  },
  event: {
    SUBMITTED: 'Отправлено на проверку',
    APPROVED: 'Согласовано',
    SCHEDULED: 'Запланировано',
    STARTED: 'Запущено',
    PAUSED: 'Приостановлено',
    RESUMED: 'Продолжено',
    CANCELLED: 'Отменено',
    COMPLETED: 'Завершено',
    FAILED: 'Ошибка',
    RECOVERED: 'Восстановлено',
  },
} as const;

export const newsletterEditorDe = {
  palette: 'Inhaltsblöcke',
  personalizationHint:
    'Personalisierung: {{ recipient.firstName | fallback: "Hello" }}. Nur freigegebene Variablen mit Fallback werden gespeichert.',
  blocks: {
    HEADING: 'Überschrift',
    TEXT: 'Text',
    IMAGE: 'Bild',
    BUTTON: 'Schaltfläche',
    DIVIDER: 'Trennlinie',
    COLUMNS: 'Spalten',
    PRODUCT: 'Produkt',
    CATALOG: 'Artikelkatalog',
    PORTAL_LINK: 'Portal-Link',
    SOCIAL_LINKS: 'Social Links',
    CUSTOM: 'Freier Inhalt',
    dividerHint: 'Die Trennlinie benötigt keine weiteren Angaben.',
  },
  actions: {
    drag: 'Block verschieben',
    removeBlock: 'Block entfernen',
    addLink: 'Link hinzufügen',
    edit: 'Bearbeiten',
    preview: 'Vorschau',
  },
  fields: {
    content: 'Inhalt',
    headingLevel: 'Überschriftenebene',
    heading: 'Überschrift',
    dmsImage: 'DMS-Bild',
    selectDmsImage: 'DMS-Bild auswählen',
    altText: 'Alternativtext',
    optionalLink: 'Optionaler HTTPS-Link',
    buttonLabel: 'Schaltflächentext',
    secureUrl: 'HTTPS-URL',
    optionalHeading: 'Optionale Überschrift',
    optionalDescription: 'Optionale Beschreibung',
    product: 'Artikel',
    selectProduct: 'Artikel auswählen',
    linkLabel: 'Linkbezeichnung',
    backgroundColor: 'Hintergrundfarbe',
    languages: 'Kampagnensprachen',
    subject: 'Betreff',
    preheader: 'Preheader',
    name: 'Name',
    description: 'Beschreibung',
    language: 'Sprache',
    brand: 'Versandmarke',
    topic: 'Newsletter-Thema',
    audience: 'Zielgruppe',
    noAudience: 'Noch keine Zielgruppe',
    template: 'Vorlage',
    noTemplate: 'Ohne Vorlage',
    senderName: 'Absendername',
    replyTo: 'Reply-To',
    individualTracking: 'Individuelles Öffnungs- und Klicktracking anfordern',
    individualTrackingHint:
      'Standardmäßig aus. Die Freigabe gelingt nur bei zwei dokumentierten Mandantenfreigaben und der finalen Empfängerprüfung; Messwerte bleiben technisch ungenau.',
    trackingPurpose: 'Dokumentierter Trackingzweck',
    utm: 'UTM-Parameter verwenden',
    utmSource: 'UTM-Quelle',
    utmMedium: 'UTM-Medium',
    utmCampaign: 'UTM-Kampagne',
  },
  footer: {
    title: 'Pflicht-Footer (gesperrt)',
    locked:
      'Absender, Firmenangaben, Kontakt, Impressum, Datenschutz, Widerspruch und Abmeldung werden serverseitig eingesetzt und können nicht entfernt werden.',
  },
  validation: {
    content: 'Inhalt und alle gewählten Sprachen vollständig ausfüllen.',
    brand: 'Alle Pflichtangaben der Versandmarke vollständig ausfüllen.',
    campaign: 'Kampagnenkopf und mehrsprachige Inhalte vollständig ausfüllen.',
  },
  messages: {
    saved: 'Version wurde unveränderlich gespeichert.',
    saveFailed: 'Newsletter-Inhalt konnte nicht gespeichert werden.',
    brandSaved: 'Pflichtangaben der Versandmarke wurden gespeichert.',
  },
  templates: {
    title: 'Newsletter-Vorlagen',
    description: 'Wiederverwendbare, versionierte und responsive Inhaltsstrukturen.',
    create: 'Neue Vorlage',
    empty: 'Noch keine Vorlage vorhanden.',
    dialogTitle: 'Vorlage bearbeiten',
    dialogDescription: 'Jedes Speichern erzeugt eine neue, unveränderliche Version.',
  },
  brand: {
    title: 'Pflichtangaben der Versandmarke',
    description:
      'Diese Angaben erscheinen in jeder Marketing-E-Mail. Vor Produktivbetrieb fachlich und rechtlich prüfen.',
    senderName: 'Standard-Absendername',
    replyTo: 'Standard-Reply-To',
    contactEmail: 'Kontakt-E-Mail',
    postalAddress: 'Ladungsfähige beziehungsweise erforderliche Anschrift',
    companyRegistration: 'Erforderliche Unternehmens- und Registerangaben',
    imprintUrl: 'HTTPS-Impressumslink',
    privacyUrl: 'HTTPS-Datenschutzlink',
    configure: 'Pflichtangaben konfigurieren',
    incomplete:
      'Die Versandmarke ist unvollständig. Vorschau, Freigabe und Versand bleiben gesperrt.',
  },
  campaigns: {
    title: 'Kampagnen',
    description:
      'Mehrsprachige Entwürfe mit versioniertem Inhalt und serverseitiger Versandgrundlage.',
    create: 'Neue Kampagne',
    dialogTitle: 'Kampagnenentwurf bearbeiten',
    dialogDescription:
      'Inhalt, Absender und Links werden vor dem Speichern serverseitig validiert.',
  },
  preview: {
    title: 'Serverseitige Vorschau',
    recipient: 'Berechtigter Vorschauempfänger',
    fallback: 'Fallback-Vorschau ohne Personendaten',
    desktop: 'Desktop-Vorschau',
    mobile: 'Mobilvorschau',
    dark: 'Dunkle Umgebung',
    frameTitle: 'Newsletter-Vorschau',
    failed: 'Vorschau ist wegen unvollständiger Pflichtangaben oder Inhalte nicht verfügbar.',
    loading: 'Vorschau wird geladen.',
  },
  test: {
    recipient: 'Interner Testempfänger',
    selectRecipient: 'Verifizierten Benutzer auswählen',
    sent: 'Testmail wurde an {{email}} gesendet.',
    failed: 'Testversand fehlgeschlagen.',
    send: 'Testmail senden',
  },
  workflow: newsletterWorkflowDe,
} as const;

export const newsletterEditorEn = {
  palette: 'Content blocks',
  personalizationHint:
    'Personalization: {{ recipient.firstName | fallback: "Hello" }}. Only approved variables with a fallback are stored.',
  blocks: {
    HEADING: 'Heading',
    TEXT: 'Text',
    IMAGE: 'Image',
    BUTTON: 'Button',
    DIVIDER: 'Divider',
    COLUMNS: 'Columns',
    PRODUCT: 'Product',
    CATALOG: 'Product catalog',
    PORTAL_LINK: 'Portal link',
    SOCIAL_LINKS: 'Social links',
    CUSTOM: 'Custom content',
    dividerHint: 'The divider needs no additional settings.',
  },
  actions: {
    drag: 'Move block',
    removeBlock: 'Remove block',
    addLink: 'Add link',
    edit: 'Edit',
    preview: 'Preview',
  },
  fields: {
    content: 'Content',
    headingLevel: 'Heading level',
    heading: 'Heading',
    dmsImage: 'DMS image',
    selectDmsImage: 'Select DMS image',
    altText: 'Alternative text',
    optionalLink: 'Optional HTTPS link',
    buttonLabel: 'Button label',
    secureUrl: 'HTTPS URL',
    optionalHeading: 'Optional heading',
    optionalDescription: 'Optional description',
    product: 'Product',
    selectProduct: 'Select product',
    linkLabel: 'Link label',
    backgroundColor: 'Background color',
    languages: 'Campaign languages',
    subject: 'Subject',
    preheader: 'Preheader',
    name: 'Name',
    description: 'Description',
    language: 'Language',
    brand: 'Sending brand',
    topic: 'Newsletter topic',
    audience: 'Audience',
    noAudience: 'No audience yet',
    template: 'Template',
    noTemplate: 'No template',
    senderName: 'Sender name',
    replyTo: 'Reply-To',
    individualTracking: 'Request individual open and click tracking',
    individualTrackingHint:
      'Off by default. Approval requires two documented tenant approvals and the final recipient check; measurements remain technically approximate.',
    trackingPurpose: 'Documented tracking purpose',
    utm: 'Use UTM parameters',
    utmSource: 'UTM source',
    utmMedium: 'UTM medium',
    utmCampaign: 'UTM campaign',
  },
  footer: {
    title: 'Mandatory footer (locked)',
    locked:
      'Sender, company details, contact, legal notice, privacy, objection and unsubscribe are inserted server-side and cannot be removed.',
  },
  validation: {
    content: 'Complete the content and every selected language.',
    brand: 'Complete all mandatory sending-brand details.',
    campaign: 'Complete the campaign header and multilingual content.',
  },
  messages: {
    saved: 'The immutable version was saved.',
    saveFailed: 'Newsletter content could not be saved.',
    brandSaved: 'Mandatory sending-brand details were saved.',
  },
  templates: {
    title: 'Newsletter templates',
    description: 'Reusable, versioned and responsive content structures.',
    create: 'New template',
    empty: 'No template yet.',
    dialogTitle: 'Edit template',
    dialogDescription: 'Every save creates a new immutable version.',
  },
  brand: {
    title: 'Mandatory sending-brand details',
    description:
      'These details appear in every marketing email. Obtain professional and legal review before production.',
    senderName: 'Default sender name',
    replyTo: 'Default Reply-To',
    contactEmail: 'Contact email',
    postalAddress: 'Serviceable or otherwise required postal address',
    companyRegistration: 'Required company and register details',
    imprintUrl: 'HTTPS legal-notice link',
    privacyUrl: 'HTTPS privacy link',
    configure: 'Configure mandatory details',
    incomplete: 'The sending brand is incomplete. Preview, approval and delivery remain blocked.',
  },
  campaigns: {
    title: 'Campaigns',
    description: 'Multilingual drafts with versioned content and server-side delivery controls.',
    create: 'New campaign',
    dialogTitle: 'Edit campaign draft',
    dialogDescription: 'Content, sender and links are validated on the server before saving.',
  },
  preview: {
    title: 'Server-side preview',
    recipient: 'Authorized preview recipient',
    fallback: 'Fallback preview without personal data',
    desktop: 'Desktop preview',
    mobile: 'Mobile preview',
    dark: 'Dark environment',
    frameTitle: 'Newsletter preview',
    failed: 'Preview is unavailable because mandatory details or content are incomplete.',
    loading: 'Loading preview.',
  },
  test: {
    recipient: 'Internal test recipient',
    selectRecipient: 'Select verified user',
    sent: 'Test email sent to {{email}}.',
    failed: 'Test delivery failed.',
    send: 'Send test email',
  },
  workflow: newsletterWorkflowEn,
} as const;

export const newsletterEditorTr = {
  palette: 'İçerik blokları',
  personalizationHint:
    'Kişiselleştirme: {{ recipient.firstName | fallback: "Hello" }}. Yalnızca yedek metinli onaylı değişkenler kaydedilir.',
  blocks: {
    HEADING: 'Başlık',
    TEXT: 'Metin',
    IMAGE: 'Görsel',
    BUTTON: 'Düğme',
    DIVIDER: 'Ayırıcı',
    COLUMNS: 'Sütunlar',
    PRODUCT: 'Ürün',
    CATALOG: 'Ürün kataloğu',
    PORTAL_LINK: 'Portal bağlantısı',
    SOCIAL_LINKS: 'Sosyal bağlantılar',
    CUSTOM: 'Serbest içerik',
    dividerHint: 'Ayırıcı ek ayar gerektirmez.',
  },
  actions: {
    drag: 'Bloğu taşı',
    removeBlock: 'Bloğu kaldır',
    addLink: 'Bağlantı ekle',
    edit: 'Düzenle',
    preview: 'Önizleme',
  },
  fields: {
    content: 'İçerik',
    headingLevel: 'Başlık düzeyi',
    heading: 'Başlık',
    dmsImage: 'DMS görseli',
    selectDmsImage: 'DMS görseli seç',
    altText: 'Alternatif metin',
    optionalLink: 'İsteğe bağlı HTTPS bağlantısı',
    buttonLabel: 'Düğme metni',
    secureUrl: 'HTTPS URL',
    optionalHeading: 'İsteğe bağlı başlık',
    optionalDescription: 'İsteğe bağlı açıklama',
    product: 'Ürün',
    selectProduct: 'Ürün seç',
    linkLabel: 'Bağlantı etiketi',
    backgroundColor: 'Arka plan rengi',
    languages: 'Kampanya dilleri',
    subject: 'Konu',
    preheader: 'Ön başlık',
    name: 'Ad',
    description: 'Açıklama',
    language: 'Dil',
    brand: 'Gönderici marka',
    topic: 'Bülten konusu',
    audience: 'Hedef kitle',
    noAudience: 'Henüz hedef kitle yok',
    template: 'Şablon',
    noTemplate: 'Şablonsuz',
    senderName: 'Gönderen adı',
    replyTo: 'Yanıt adresi',
    individualTracking: 'Bireysel açılma ve tıklama takibi iste',
    individualTrackingHint:
      'Varsayılan olarak kapalıdır. Onay için iki belgeli kiracı onayı ve son alıcı kontrolü gerekir; ölçümler teknik olarak yaklaşık kalır.',
    trackingPurpose: 'Belgelenmiş takip amacı',
    utm: 'UTM parametrelerini kullan',
    utmSource: 'UTM kaynağı',
    utmMedium: 'UTM ortamı',
    utmCampaign: 'UTM kampanyası',
  },
  footer: {
    title: 'Zorunlu altbilgi (kilitli)',
    locked:
      'Gönderen, şirket, iletişim, yasal bildirim, gizlilik, itiraz ve abonelikten çıkma bilgileri sunucuda eklenir ve kaldırılamaz.',
  },
  validation: {
    content: 'İçeriği ve seçilen tüm dilleri tamamlayın.',
    brand: 'Gönderici markanın zorunlu bilgilerini tamamlayın.',
    campaign: 'Kampanya başlığını ve çok dilli içeriği tamamlayın.',
  },
  messages: {
    saved: 'Değiştirilemez sürüm kaydedildi.',
    saveFailed: 'Bülten içeriği kaydedilemedi.',
    brandSaved: 'Zorunlu marka bilgileri kaydedildi.',
  },
  templates: {
    title: 'Bülten şablonları',
    description: 'Yeniden kullanılabilir, sürümlü ve duyarlı içerik yapıları.',
    create: 'Yeni şablon',
    empty: 'Henüz şablon yok.',
    dialogTitle: 'Şablonu düzenle',
    dialogDescription: 'Her kayıt yeni ve değiştirilemez bir sürüm oluşturur.',
  },
  brand: {
    title: 'Gönderici markanın zorunlu bilgileri',
    description:
      'Bu bilgiler her pazarlama e-postasında görünür. Canlı kullanımdan önce uzman ve hukuki inceleme yaptırın.',
    senderName: 'Varsayılan gönderen adı',
    replyTo: 'Varsayılan yanıt adresi',
    contactEmail: 'İletişim e-postası',
    postalAddress: 'Tebligata elverişli veya gerekli posta adresi',
    companyRegistration: 'Gerekli şirket ve sicil bilgileri',
    imprintUrl: 'HTTPS yasal bildirim bağlantısı',
    privacyUrl: 'HTTPS gizlilik bağlantısı',
    configure: 'Zorunlu bilgileri yapılandır',
    incomplete: 'Gönderici marka eksik. Önizleme, onay ve gönderim engellenir.',
  },
  campaigns: {
    title: 'Kampanyalar',
    description: 'Sürümlü içerik ve sunucu tarafı gönderim kontrolleriyle çok dilli taslaklar.',
    create: 'Yeni kampanya',
    dialogTitle: 'Kampanya taslağını düzenle',
    dialogDescription: 'İçerik, gönderen ve bağlantılar kayıttan önce sunucuda doğrulanır.',
  },
  preview: {
    title: 'Sunucu tarafı önizleme',
    recipient: 'Yetkili önizleme alıcısı',
    fallback: 'Kişisel veri içermeyen yedek önizleme',
    desktop: 'Masaüstü önizleme',
    mobile: 'Mobil önizleme',
    dark: 'Koyu ortam',
    frameTitle: 'Bülten önizlemesi',
    failed: 'Zorunlu bilgiler veya içerik eksik olduğundan önizleme kullanılamıyor.',
    loading: 'Önizleme yükleniyor.',
  },
  test: {
    recipient: 'Dahili test alıcısı',
    selectRecipient: 'Doğrulanmış kullanıcı seç',
    sent: 'Test e-postası {{email}} adresine gönderildi.',
    failed: 'Test gönderimi başarısız.',
    send: 'Test e-postası gönder',
  },
  workflow: newsletterWorkflowTr,
} as const;

export const newsletterEditorFr = {
  palette: 'Blocs de contenu',
  personalizationHint:
    'Personnalisation : {{ recipient.firstName | fallback: "Hello" }}. Seules les variables approuvées avec valeur de repli sont enregistrées.',
  blocks: {
    HEADING: 'Titre',
    TEXT: 'Texte',
    IMAGE: 'Image',
    BUTTON: 'Bouton',
    DIVIDER: 'Séparateur',
    COLUMNS: 'Colonnes',
    PRODUCT: 'Produit',
    CATALOG: 'Catalogue produits',
    PORTAL_LINK: 'Lien portail',
    SOCIAL_LINKS: 'Liens sociaux',
    CUSTOM: 'Contenu libre',
    dividerHint: 'Le séparateur ne nécessite aucun réglage.',
  },
  actions: {
    drag: 'Déplacer le bloc',
    removeBlock: 'Supprimer le bloc',
    addLink: 'Ajouter un lien',
    edit: 'Modifier',
    preview: 'Aperçu',
  },
  fields: {
    content: 'Contenu',
    headingLevel: 'Niveau de titre',
    heading: 'Titre',
    dmsImage: 'Image DMS',
    selectDmsImage: 'Choisir une image DMS',
    altText: 'Texte alternatif',
    optionalLink: 'Lien HTTPS facultatif',
    buttonLabel: 'Texte du bouton',
    secureUrl: 'URL HTTPS',
    optionalHeading: 'Titre facultatif',
    optionalDescription: 'Description facultative',
    product: 'Produit',
    selectProduct: 'Choisir un produit',
    linkLabel: 'Libellé du lien',
    backgroundColor: 'Couleur de fond',
    languages: 'Langues de campagne',
    subject: 'Objet',
    preheader: 'Pré-en-tête',
    name: 'Nom',
    description: 'Description',
    language: 'Langue',
    brand: 'Marque expéditrice',
    topic: 'Thème de newsletter',
    audience: 'Audience',
    noAudience: 'Aucune audience',
    template: 'Modèle',
    noTemplate: 'Sans modèle',
    senderName: 'Nom de l’expéditeur',
    replyTo: 'Adresse de réponse',
    individualTracking: 'Demander le suivi individuel des ouvertures et clics',
    individualTrackingHint:
      'Désactivé par défaut. L’approbation exige deux validations documentées du tenant et le contrôle final du destinataire ; les mesures restent techniquement approximatives.',
    trackingPurpose: 'Finalité documentée du suivi',
    utm: 'Utiliser les paramètres UTM',
    utmSource: 'Source UTM',
    utmMedium: 'Support UTM',
    utmCampaign: 'Campagne UTM',
  },
  footer: {
    title: 'Pied de page obligatoire (verrouillé)',
    locked:
      'Expéditeur, société, contact, mentions légales, confidentialité, opposition et désinscription sont ajoutés côté serveur et ne peuvent être supprimés.',
  },
  validation: {
    content: 'Complétez le contenu et toutes les langues choisies.',
    brand: 'Complétez les mentions obligatoires de la marque.',
    campaign: 'Complétez l’en-tête et le contenu multilingue.',
  },
  messages: {
    saved: 'La version immuable a été enregistrée.',
    saveFailed: 'Impossible d’enregistrer le contenu.',
    brandSaved: 'Les mentions obligatoires ont été enregistrées.',
  },
  templates: {
    title: 'Modèles de newsletter',
    description: 'Structures réutilisables, versionnées et adaptatives.',
    create: 'Nouveau modèle',
    empty: 'Aucun modèle.',
    dialogTitle: 'Modifier le modèle',
    dialogDescription: 'Chaque enregistrement crée une version immuable.',
  },
  brand: {
    title: 'Mentions obligatoires de la marque',
    description:
      'Ces mentions figurent dans chaque e-mail marketing. Faites-les examiner avant production.',
    senderName: 'Nom d’expéditeur par défaut',
    replyTo: 'Adresse de réponse par défaut',
    contactEmail: 'E-mail de contact',
    postalAddress: 'Adresse postale requise ou permettant la signification',
    companyRegistration: 'Mentions de société et de registre requises',
    imprintUrl: 'Lien HTTPS vers les mentions légales',
    privacyUrl: 'Lien HTTPS de confidentialité',
    configure: 'Configurer les mentions',
    incomplete: 'La marque est incomplète. Aperçu, approbation et envoi restent bloqués.',
  },
  campaigns: {
    title: 'Campagnes',
    description: 'Brouillons multilingues avec contenu versionné et contrôles serveur.',
    create: 'Nouvelle campagne',
    dialogTitle: 'Modifier le brouillon',
    dialogDescription:
      'Contenu, expéditeur et liens sont validés par le serveur avant enregistrement.',
  },
  preview: {
    title: 'Aperçu côté serveur',
    recipient: 'Destinataire autorisé pour l’aperçu',
    fallback: 'Aperçu de repli sans données personnelles',
    desktop: 'Aperçu ordinateur',
    mobile: 'Aperçu mobile',
    dark: 'Environnement sombre',
    frameTitle: 'Aperçu de newsletter',
    failed: 'Aperçu indisponible car des mentions ou contenus sont incomplets.',
    loading: 'Chargement de l’aperçu.',
  },
  test: {
    recipient: 'Destinataire de test interne',
    selectRecipient: 'Choisir un utilisateur vérifié',
    sent: 'E-mail de test envoyé à {{email}}.',
    failed: 'Échec de l’envoi test.',
    send: 'Envoyer le test',
  },
  workflow: newsletterWorkflowFr,
} as const;

export const newsletterEditorEs = {
  palette: 'Bloques de contenido',
  personalizationHint:
    'Personalización: {{ recipient.firstName | fallback: "Hello" }}. Solo se guardan variables aprobadas con valor alternativo.',
  blocks: {
    HEADING: 'Encabezado',
    TEXT: 'Texto',
    IMAGE: 'Imagen',
    BUTTON: 'Botón',
    DIVIDER: 'Separador',
    COLUMNS: 'Columnas',
    PRODUCT: 'Producto',
    CATALOG: 'Catálogo',
    PORTAL_LINK: 'Enlace del portal',
    SOCIAL_LINKS: 'Enlaces sociales',
    CUSTOM: 'Contenido libre',
    dividerHint: 'El separador no necesita más ajustes.',
  },
  actions: {
    drag: 'Mover bloque',
    removeBlock: 'Eliminar bloque',
    addLink: 'Añadir enlace',
    edit: 'Editar',
    preview: 'Vista previa',
  },
  fields: {
    content: 'Contenido',
    headingLevel: 'Nivel de encabezado',
    heading: 'Encabezado',
    dmsImage: 'Imagen DMS',
    selectDmsImage: 'Seleccionar imagen DMS',
    altText: 'Texto alternativo',
    optionalLink: 'Enlace HTTPS opcional',
    buttonLabel: 'Texto del botón',
    secureUrl: 'URL HTTPS',
    optionalHeading: 'Encabezado opcional',
    optionalDescription: 'Descripción opcional',
    product: 'Producto',
    selectProduct: 'Seleccionar producto',
    linkLabel: 'Etiqueta del enlace',
    backgroundColor: 'Color de fondo',
    languages: 'Idiomas de campaña',
    subject: 'Asunto',
    preheader: 'Preencabezado',
    name: 'Nombre',
    description: 'Descripción',
    language: 'Idioma',
    brand: 'Marca remitente',
    topic: 'Tema del boletín',
    audience: 'Audiencia',
    noAudience: 'Sin audiencia',
    template: 'Plantilla',
    noTemplate: 'Sin plantilla',
    senderName: 'Nombre del remitente',
    replyTo: 'Dirección de respuesta',
    individualTracking: 'Solicitar seguimiento individual de aperturas y clics',
    individualTrackingHint:
      'Desactivado por defecto. La aprobación exige dos autorizaciones documentadas del tenant y la comprobación final del destinatario; las mediciones siguen siendo técnicamente aproximadas.',
    trackingPurpose: 'Finalidad documentada del seguimiento',
    utm: 'Usar parámetros UTM',
    utmSource: 'Fuente UTM',
    utmMedium: 'Medio UTM',
    utmCampaign: 'Campaña UTM',
  },
  footer: {
    title: 'Pie obligatorio (bloqueado)',
    locked:
      'Remitente, empresa, contacto, aviso legal, privacidad, oposición y baja se añaden en el servidor y no se pueden eliminar.',
  },
  validation: {
    content: 'Complete el contenido y todos los idiomas seleccionados.',
    brand: 'Complete los datos obligatorios de la marca.',
    campaign: 'Complete la cabecera y el contenido multilingüe.',
  },
  messages: {
    saved: 'Se guardó la versión inmutable.',
    saveFailed: 'No se pudo guardar el contenido.',
    brandSaved: 'Se guardaron los datos obligatorios.',
  },
  templates: {
    title: 'Plantillas de boletín',
    description: 'Estructuras reutilizables, versionadas y adaptables.',
    create: 'Nueva plantilla',
    empty: 'Todavía no hay plantillas.',
    dialogTitle: 'Editar plantilla',
    dialogDescription: 'Cada guardado crea una versión inmutable.',
  },
  brand: {
    title: 'Datos obligatorios de la marca',
    description:
      'Aparecen en todos los correos de marketing. Solicite revisión profesional y legal antes de producción.',
    senderName: 'Nombre de remitente predeterminado',
    replyTo: 'Dirección de respuesta predeterminada',
    contactEmail: 'Correo de contacto',
    postalAddress: 'Dirección postal requerida o apta para notificaciones',
    companyRegistration: 'Datos empresariales y registrales requeridos',
    imprintUrl: 'Enlace HTTPS al aviso legal',
    privacyUrl: 'Enlace HTTPS de privacidad',
    configure: 'Configurar datos obligatorios',
    incomplete: 'La marca está incompleta. Vista previa, aprobación y envío siguen bloqueados.',
  },
  campaigns: {
    title: 'Campañas',
    description: 'Borradores multilingües con contenido versionado y controles de servidor.',
    create: 'Nueva campaña',
    dialogTitle: 'Editar borrador',
    dialogDescription: 'El contenido, remitente y enlaces se validan en el servidor.',
  },
  preview: {
    title: 'Vista previa del servidor',
    recipient: 'Destinatario autorizado para vista previa',
    fallback: 'Vista alternativa sin datos personales',
    desktop: 'Vista de escritorio',
    mobile: 'Vista móvil',
    dark: 'Entorno oscuro',
    frameTitle: 'Vista previa del boletín',
    failed: 'La vista no está disponible porque faltan datos o contenido.',
    loading: 'Cargando vista previa.',
  },
  test: {
    recipient: 'Destinatario interno de prueba',
    selectRecipient: 'Seleccionar usuario verificado',
    sent: 'Correo de prueba enviado a {{email}}.',
    failed: 'Falló el envío de prueba.',
    send: 'Enviar prueba',
  },
  workflow: newsletterWorkflowEs,
} as const;

export const newsletterEditorRu = {
  palette: 'Блоки содержимого',
  personalizationHint:
    'Персонализация: {{ recipient.firstName | fallback: "Hello" }}. Сохраняются только разрешённые переменные с резервным текстом.',
  blocks: {
    HEADING: 'Заголовок',
    TEXT: 'Текст',
    IMAGE: 'Изображение',
    BUTTON: 'Кнопка',
    DIVIDER: 'Разделитель',
    COLUMNS: 'Колонки',
    PRODUCT: 'Товар',
    CATALOG: 'Каталог',
    PORTAL_LINK: 'Ссылка на портал',
    SOCIAL_LINKS: 'Социальные ссылки',
    CUSTOM: 'Свободный блок',
    dividerHint: 'Разделитель не требует настроек.',
  },
  actions: {
    drag: 'Переместить блок',
    removeBlock: 'Удалить блок',
    addLink: 'Добавить ссылку',
    edit: 'Изменить',
    preview: 'Предпросмотр',
  },
  fields: {
    content: 'Содержимое',
    headingLevel: 'Уровень заголовка',
    heading: 'Заголовок',
    dmsImage: 'Изображение DMS',
    selectDmsImage: 'Выбрать изображение DMS',
    altText: 'Альтернативный текст',
    optionalLink: 'Необязательная ссылка HTTPS',
    buttonLabel: 'Текст кнопки',
    secureUrl: 'URL HTTPS',
    optionalHeading: 'Необязательный заголовок',
    optionalDescription: 'Необязательное описание',
    product: 'Товар',
    selectProduct: 'Выбрать товар',
    linkLabel: 'Название ссылки',
    backgroundColor: 'Цвет фона',
    languages: 'Языки кампании',
    subject: 'Тема',
    preheader: 'Предзаголовок',
    name: 'Название',
    description: 'Описание',
    language: 'Язык',
    brand: 'Бренд отправителя',
    topic: 'Тема рассылки',
    audience: 'Аудитория',
    noAudience: 'Аудитория не выбрана',
    template: 'Шаблон',
    noTemplate: 'Без шаблона',
    senderName: 'Имя отправителя',
    replyTo: 'Адрес для ответа',
    individualTracking: 'Запросить индивидуальное отслеживание открытий и переходов',
    individualTrackingHint:
      'По умолчанию выключено. Для утверждения нужны две документированные проверки арендатора и финальная проверка получателя; показатели технически приблизительны.',
    trackingPurpose: 'Документированная цель отслеживания',
    utm: 'Использовать UTM-параметры',
    utmSource: 'Источник UTM',
    utmMedium: 'Канал UTM',
    utmCampaign: 'Кампания UTM',
  },
  footer: {
    title: 'Обязательный подвал (заблокирован)',
    locked:
      'Отправитель, реквизиты, контакты, правовая информация, конфиденциальность, возражение и отписка добавляются сервером и не удаляются.',
  },
  validation: {
    content: 'Заполните содержимое на всех выбранных языках.',
    brand: 'Заполните обязательные данные бренда.',
    campaign: 'Заполните параметры и многоязычное содержимое кампании.',
  },
  messages: {
    saved: 'Неизменяемая версия сохранена.',
    saveFailed: 'Не удалось сохранить содержимое.',
    brandSaved: 'Обязательные данные бренда сохранены.',
  },
  templates: {
    title: 'Шаблоны рассылок',
    description: 'Повторно используемые, версионные и адаптивные структуры.',
    create: 'Новый шаблон',
    empty: 'Шаблонов пока нет.',
    dialogTitle: 'Изменить шаблон',
    dialogDescription: 'Каждое сохранение создаёт новую неизменяемую версию.',
  },
  brand: {
    title: 'Обязательные данные бренда',
    description:
      'Они входят в каждое маркетинговое письмо. До запуска нужна профессиональная и юридическая проверка.',
    senderName: 'Имя отправителя по умолчанию',
    replyTo: 'Адрес ответа по умолчанию',
    contactEmail: 'Контактный адрес',
    postalAddress: 'Требуемый почтовый адрес для юридически значимых сообщений',
    companyRegistration: 'Требуемые реквизиты компании и реестра',
    imprintUrl: 'HTTPS-ссылка на правовую информацию',
    privacyUrl: 'HTTPS-ссылка на конфиденциальность',
    configure: 'Настроить обязательные данные',
    incomplete: 'Данные бренда неполны. Предпросмотр, согласование и отправка заблокированы.',
  },
  campaigns: {
    title: 'Кампании',
    description: 'Многоязычные черновики с версионным содержимым и серверными проверками.',
    create: 'Новая кампания',
    dialogTitle: 'Изменить черновик',
    dialogDescription: 'Содержимое, отправитель и ссылки проверяются сервером.',
  },
  preview: {
    title: 'Серверный предпросмотр',
    recipient: 'Разрешённый получатель предпросмотра',
    fallback: 'Резервный просмотр без персональных данных',
    desktop: 'Настольный вид',
    mobile: 'Мобильный вид',
    dark: 'Тёмное окружение',
    frameTitle: 'Предпросмотр рассылки',
    failed: 'Предпросмотр недоступен из-за неполных данных или содержимого.',
    loading: 'Загрузка предпросмотра.',
  },
  test: {
    recipient: 'Внутренний тестовый получатель',
    selectRecipient: 'Выбрать подтверждённого пользователя',
    sent: 'Тестовое письмо отправлено на {{email}}.',
    failed: 'Ошибка тестовой отправки.',
    send: 'Отправить тест',
  },
  workflow: newsletterWorkflowRu,
} as const;
